import React, { Component } from 'react';
import { DatePicker, Input, Button, Select, Modal } from 'antd';
// import FloatingInputs from "../../components/FloatingLabel";
import { ArrowLeftOutlined, LoadingOutlined } from '@ant-design/icons';
import { withRouter } from "react-router-dom";
import axios from "axios";
// import Map from '../../components/Map';
import { connect } from 'react-redux';
import Swal from 'sweetalert2';
import moment from 'moment';
import i18next from 'i18next';
import { Trash2 } from "lucide-react"; // Importing Lucide Trash icon
import Trash from '../../../assets/images/icons/trash.svg'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const { Option } = Select;

const { TextArea } = Input;


const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
});


class MyListingDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: undefined,
            date_format: 'DD-MM-YYYY',
            categories: [],
            sub_categories: [],
            task_name: "",
            is_location_ModalVisible: false,
            location2: '',
            location1: '',
            // description: '   ',
            show_hide_map: false,
            chosen_subcat: 'Select Sub Category',
            is_disabled: false,
            images: [],  // New: Image file state,
            countries: [], // New state for countries
            cities: [], // New state for cities
            selectedCountry: '', // New state to track selected country
            selectedCity: '',
            description_err: '',
            country_err: '', // Error message for country selection
            city_err: '', // 
            activeIndex: null,
        }
    }
    onChange = value => {
        this.setState({ value });
    };
    UNSAFE_componentWillMount = () => {
        console.log("enters will mount");

        this.get_categories();
        this.get_countries(); // Fetch countries on mount
        // this.get_cities(); // Fetch countries on mount

    }

    componentDidMount = () => {
    console.log('Location state in MyListingDetail:', this.props.location.state);


        this.get_listing_by_id();
    }


    get_listing_by_id = () => {
        var general_info = JSON.parse(localStorage.getItem('general_info'));
        // console.log('LISTINGID',listing_id);return

        var listing_id = '';
        var user_info = JSON.parse(localStorage.getItem('user'));
        if(this.props.location.state === undefined) {
            this.props.history.push("/user/my-listing");
        }
        else {
            listing_id = this.props.location.state.listing_id;
        }
        this.setState({ initial_state : this.props.location.state, general_info : general_info,user_info : user_info })
        if(listing_id !==  '') {
            axios.get(`${process.env.REACT_APP_BASE_URL}/web/api/v1/user/listingdetails/${listing_id}`)
            .then(res => {
                if(res.data.status_code === 200)
                {
                console.log('DAE',res.data)
                    var booking_details = res.data;
                    // console.log('BB',booking_details)
                    var raw_date =res.data.date;
                    let date = new Date(raw_date);
                    // booking_details.images= booking_details.images.map(img => ({ img: img })) || [];

                    let formatted_date =date.getDate() + "/"+ parseInt(date.getMonth()+1) +"/"+date.getFullYear();

                     // Load existing images
                    let existingImages = res.data.images.map(img => ({
                        url: img, // API returns image URLs
                        file: null, // Placeholder, since these are existing images
                        isExisting: true // Mark as existing image

                    }));

                    booking_details.formatted_date = formatted_date;
                    console.log('FORMAT',formatted_date);
                    
                    this.setState({ booking_details : booking_details, images: existingImages,task_name: booking_details.bookedName,
                        sale_price: booking_details.price, description: booking_details.description, // Set the initial sale_price from the booking details
                        is_loading : false },()=>{
                    });
                }
                else if(res.data.status_code === 401) {
                    localStorage.removeItem('access_token');
                    localStorage.removeItem('user');
                    this.props.history.push('/');
                    window.location.reload(false);
                }
            });
        }
    }

    // Fetch countries
    // get_countries = () => {
    //     axios.get(`${process.env.REACT_APP_BASE_URL}/web/api/v1/countries`)
    //         .then(res => {
    //             if (res.data.status_code === 200) {
    //                 this.setState({ countries: res.data.countries });
    //             } else {
    //                 console.log('MES', res.data.message);
    //             }
    //         });
    // }

    deleteListing = () => {
        var general_info = JSON.parse(localStorage.getItem('general_info'));
        // console.log('LISTINGID',listing_id);return

        var listing_id = '';
        var user_info = JSON.parse(localStorage.getItem('user'));
        if(this.props.location.state === undefined) {
            this.props.history.push("/user/my-listing");
        }
        else {                                                                                                                          
            listing_id = this.props.location.state.listing_id;
        }
        // console.log('LISTY',listing_id);return;

        if(listing_id !==  '') {
            axios.delete(`${process.env.REACT_APP_BASE_URL}/web/api/v1/user/deletelisting/${listing_id}`)
            .then(res => {
                if (res.data.status_code === 200) {
                    Toast.fire({
                        icon: 'success',
                        title: i18next.t('Deleted Successfully!')
                    });
                    this.props.history.push('/user/my-listing');
                } else if (res.data.status_code === 401) {
                } else {
                    this.setState({ is_disabled: false });
                    Toast.fire({
                        icon: 'warning',
                        title: "Something went wrong!"
                    });
                }
            });
        }

    }


    get_countries = () => {
        axios.get(`${process.env.REACT_APP_BASE_URL}/web/api/v1/countries`)
            .then(res => {
                if (res.data.status_code === 200) {
                    this.setState({ countries: res.data.countries }, () => {
                        if (this.state.booking_details?.country) {
                            // Fetch cities for the selected country
                            let selectedCountry = this.state.booking_details.country;
                            let countryObj = res.data.countries.find(c => c.name === selectedCountry);
                            console.log('countryObj',countryObj.name);
                            
                            if (countryObj) {
                                this.get_cities(countryObj.name);
                            }
                        }
                    });
                } else {
                    console.log('MES', res.data.message);
                }
            })
            .catch(err => console.error("Error fetching countries:", err));
    };
    

    // Fetch cities based on selected country
    // get_cities = (countryId) => {
    //     axios.get(`${process.env.REACT_APP_BASE_URL}/web/api/v1/cities/${countryId}`) // Change `?countryId=` to `/${countryId}`
    //         .then(res => {
    //             console.log("Cities API Response:", res.data); // Debugging

    //             if (res.data.status_code === 200) {
    //                 this.setState({ cities: res.data.cities });
    //             } else {
    //                 console.log("No cities found:", res.data.message);
    //                 this.setState({ cities: [] });
    //             }
    //         })
    //         .catch(err => console.error("Error fetching cities:", err));

    // };


    get_cities = (countryId) => {
        axios.get(`${process.env.REACT_APP_BASE_URL}/web/api/v1/cities/${countryId}`)
            .then(res => {
                if (res.data.status_code === 200) {
                    console.log('CITIES',res.data.cities);
                    
                    this.setState({ cities: res.data.cities }, () => {

                        if (this.state.booking_details?.city) {
                            let selectedCity = this.state.booking_details.city;
                            let cityExists = res.data.cities.includes(selectedCity);
                            if (!cityExists) {
                                this.setState({ booking_details: { ...this.state.booking_details, city: "" } });
                            }
                        }
                    });
                } else {
                    console.log("No cities found:", res.data.message);
                    this.setState({ cities: [] });
                }
            })
            .catch(err => console.error("Error fetching cities:", err));
    };
    



    handleCountryChange = (value) => {
        let countryObj = this.state.countries.find(c => c.name === value);
        this.setState({ 
            booking_details: { ...this.state.booking_details, country: value, city: "" },
            cities: []
        });
console.log('COUNT',countryObj.name)
        if (countryObj) {
            this.get_cities(countryObj.name);
        }
    };
    
    handleCityChange = (value) => {
        this.setState({ booking_details: { ...this.state.booking_details, city: value } });
    };
    
    // Handle city selection
    // handleCityChange = (value) => {
    //     this.setState({ selectedCity: value });
    // }


    get_categories = () => {
        var general_info = JSON.parse(localStorage.getItem('general_info'));
        var user_info = JSON.parse(localStorage.getItem('user'));
        this.setState({ general_info: general_info, user_info: user_info }, () => {
            // if (general_info.instant_location === "true") {
            //     this.get_geo_location();
            // }
        })
        axios.get(`${process.env.REACT_APP_BASE_URL}/web/api/v1/categories`)
            .then(res => {
                if (res.data.status_code === 200) {
                    this.setState({
                        categories: res.data.category,
                    });
                }
                else {
                    console.log(res.data.message);
                }
            })
    }




    // Handle file selection from input
    // handleImageUpload = (event) => {
    //     const files = event.target.files || event.dataTransfer.files;
    //     if (!files.length) return;

    //     let newImages = [...this.state.images];

    //     for (let file of files) {
    //         if (newImages.length >= 15) break; // Limit to 15 images

    //         const reader = new FileReader();
    //         reader.onload = (e) => {
    //             this.setState((prevState) => ({
    //                 images: [...prevState.images, { file, url: e.target.result }]
    //             }));
    //         };
    //         reader.readAsDataURL(file);
    //     }
    // };


    // handleImageUpload = (event) => {
    //     const files = event.target.files || event.dataTransfer.files;
    //     if (!files.length) return;
    
    //     let newImages = [...this.state.images];
    
    //     for (let file of files) {
    //         if (newImages.length >= 15) break; // Limit to 15 images
    
    //         const reader = new FileReader();
    //         reader.onload = (e) => {
    //             this.setState((prevState) => ({
    //                 images: [...prevState.images, { file, url: e.target.result }]
    //             }));
    //         };
    //         reader.readAsDataURL(file);
    //         console.log('file',file)
    //         console.log('UPPIE',this.state.images)
            

    //     }
    // };


    // handleImageUpload = (event) => {
    //     const files = event.target.files || event.dataTransfer.files;
    //     if (!files.length) return;
    
    //     let newImages = [...this.state.images];
    
    //     for (let file of files) {
    //         if (newImages.length >= 15) break; // Limit to 15 images
    
    //         // Store only the filename and file for new images
    //         const filename = file.name;  // Use the file name instead of base64
    
    //         const reader = new FileReader();
    //         reader.onload = (e) => {
    //             this.setState((prevState) => {
    //                 const updatedImages = [
    //                     ...prevState.images,
    //                     { file: filename, url: e.target.result }  // Add both file name and base64
    //                 ];
    //                 return { images: updatedImages };
    //             });
    //         };
    //         reader.readAsDataURL(file);
    //     }
    // };
    
    // handleImageUpload = (event) => {
    //     const files = event.target.files || event.dataTransfer.files;
    //     if (!files.length) return;
    
    //     let newImages = [...this.state.images];
    
    //     for (let file of files) {
    //         if (newImages.length >= 15) break; // Limit to 15 images
    
    //         // Create a temporary URL for the file
    //         const imageUrl = URL.createObjectURL(file);
    
    //         // Add the file and its URL to the state
    //         newImages.push({ file, url: imageUrl });
    //     }
    
    //     // Update the state with the new images
    //     this.setState({ images: newImages });
    // };
    
    // handleImageUpload = (event) => {
    //     const files = event.target.files || event.dataTransfer.files;
    //     if (!files.length) return;
    
    //     let newImages = [...this.state.images];
    
    //     if (newImages.length + files.length > 15) {
    //         Toast.fire({
    //             icon: 'error',
    //             title: "You can only upload up to 15 images!",
    //         });
    //         return;
    //     }
        
    //     for (let file of files) {
    //         if (newImages.length >= 15) break; // Limit to 15 images
    
    //         // Create a temporary URL for the file
    //         const imageUrl = URL.createObjectURL(file);
    
    //         // Add the file and its URL to the state
    //         newImages.push({ file, url: imageUrl });
    //     }
    
    //     // Update the state with the new images
    //     this.setState({ images: newImages });
    // };

    handleImageUpload = (event) => {
        const files = event.target.files || event.dataTransfer.files;
        if (!files.length) return;
    
        let newImages = [...this.state.images];
        // const allowedTypes = ["image/jpeg", "image/jpg", "image/png"]; // Allowed MIME types
    
        for (let file of files) {
            // if (newImages.length >= 15) break; // Ensure limit is not exceeded
    
            // if (!allowedTypes.includes(file.type)) {
            //     Toast.fire({
            //         icon: "error",
            //         title: "Only JPG, JPEG, and PNG images are allowed!",
            //     });
            //     continue; // Skip this file and move to the next
            // }
    
            // Create a temporary URL for the file
            const imageUrl = URL.createObjectURL(file);
    
            // Add the file and its URL to the state
            newImages.push({ file, url: imageUrl });
        }
    
        // if (newImages.length > 15) {
        //     Toast.fire({
        //         icon: "error",
        //         title: "You can only upload up to 15 images!",
        //     });
        //     return;
        // }
    
        // Update the state with the new images
        this.setState({ images: newImages });
    };
    


    // Handle drag over event
    handleDragOver = (event) => {
        event.preventDefault();
    };

    // Remove an image
    removeImage = (index) => {
        this.setState((prevState) => ({
            images: prevState.images.filter((_, i) => i !== index)
        }));
    };



    deg2rad = (deg) => {
        return deg * (Math.PI / 180)
    }
    // get_subcategories = (value) => {
    //     const config = {
    //         headers: {
    //             'Content-type': 'application/x-www-form-urlencoded'
    //         }
    //     }
    //     this.setState({ chosen_cat: value, chosen_subcat: 'Select Sub Category', chosen_service: 'Select Service', sub_categories: [], services: [] }, () => {
    //         var cat_id = value;
    //         if (cat_id !== '') {
    //             const params = new URLSearchParams()
    //             params.append('category_id', cat_id)
    //             axios.post(`${process.env.REACT_APP_BASE_URL}/web/api/v1/category_by_id`, params, config)
    //                 .then(res => {
    //                     console.log('bread_1');
    //                     console.log(res.data)
    //                     if (res.data.status_code === 200) {
    //                         this.setState({
    //                             category_info: res.data.category[0],
    //                         })
    //                     }
    //                 });
    //         }
    //     });

    //     var cat_id = value;
    //     if (cat_id !== '') {
    //         const params = new URLSearchParams()
    //         params.append('category_id', cat_id)
    //         axios.post(`${process.env.REACT_APP_BASE_URL}/web/api/v1/category_by_id`, params, config)
    //             .then(res => {
    //                 if (res.data.status_code === 200) {
    //                     this.setState({
    //                         category_type: res.data.category[0].parent_category_type,
    //                     })
    //                 }
    //             });
    //     }
    //     const params1 = new URLSearchParams();
    //     params1.append('parent_category_id', value);
    //     axios.post(`${process.env.REACT_APP_BASE_URL}/web/api/v1/subcategories`, params1, config)
    //         .then(res => {
    //             // console.log('result is here');
    //             // console.log(res);
    //             if (res.data.status_code === 200) {
    //                 this.setState({
    //                     sub_categories: res.data.subcategory
    //                 });
    //             }
    //             else {
    //                 console.log(res.data.message);
    //             }
    //         })
    // }



    get_subcategories = (value) => {
        const config = {
            headers: {
                'Content-type': 'application/x-www-form-urlencoded'
            }
        };
        
        this.setState(prevState => ({
            booking_details: {
                ...prevState.booking_details,
                parent_category_name: value,  // Update selected category
                subcategory_name: "",  // Reset subcategory
            },
            chosen_cat: value,
            chosen_subcat: 'Select Sub Category',
            chosen_service: 'Select Service',
            sub_categories: [],
            services: []
        }), () => {
            if (value !== '') {
                const params = new URLSearchParams();
                params.append('category_id', value);
                
                axios.post(`${process.env.REACT_APP_BASE_URL}/web/api/v1/category_by_id`, params, config)
                    .then(res => {
                        if (res.data.status_code === 200) {
                            this.setState({
                                category_info: res.data.category[0],
                                category_type: res.data.category[0].parent_category_type
                            });
                        }
                    });
    
                // Fetch subcategories
                const params1 = new URLSearchParams();
                params1.append('parent_category_id', value);
                axios.post(`${process.env.REACT_APP_BASE_URL}/web/api/v1/subcategories`, params1, config)
                    .then(res => {
                        if (res.data.status_code === 200) {
                            this.setState({ sub_categories: res.data.subcategory });
                        }
                    });
            }
        });
    };
    

    save_need = () => {
        console.log('enters save_need for update');
        this.setState({
            is_disabled: true,
        });
    
        var user_info = JSON.parse(localStorage.getItem('user'));
        var err = 0;
    
        var booking_id = '';
        if (this.props.location.state === undefined) {
            this.props.history.push("/user/my-listing");
        } else {
            booking_id = this.props.location.state.listing_id;
        }
        console.log('SUBBIE',this.state.booking_details);
        // console.log('this.state.sale_price',this.state.sale_price)
        // console.log('booking_details',this.state.booking_details.price)
        // Use existing values if no changes are made
        // const task_name = this.state.task_name || this.state.booking_details?.bookedName;



//image validation

if (!this.state.images || this.state.images.length === 0) {
    this.setState({ 
        image_err: i18next.t("At least one image is required!"), 
        is_disabled: false 
    }, () => {
        if (this.task_name) {
            setTimeout(() => {
                this.task_name.scrollIntoView({ behavior: "smooth", block: "center" });
            }, 100);
        }
    });
    err++;
    return; // 🚀 Exit early to prevent other checks
}


if (this.state.images.length > 15) {
    this.setState({ 
        image_err: i18next.t("You can upload up to 15 images only!"), 
        is_disabled: false 
    }, () => {
        if (this.task_name) {
            setTimeout(() => {
                this.task_name.scrollIntoView({ behavior: "smooth", block: "center" });
            }, 100);
        }
    });
    err++;
    return; // 🚀 Exit early to prevent other checks
}

        // Ensure each image has a valid format and size
        const allowedTypes = ["image/jpeg", "image/png", "image/jpg", "image/gif"];
        const maxSize = 5 * 1024 * 1024; // 5MB

        let imageError = "";  // Store error message
        let shouldScroll = false;  // Track if we need to scroll

        for (let i = 0; i < this.state.images.length; i++) {
            let imageObj = this.state.images[i]; 
        
            // Skip validation for existing images (from database)
            if (imageObj.isExisting) {
                continue;
            }
        
            let image = imageObj.file;
        
            if (!image) {
                continue; // If somehow file is null but not existing, skip it
            }
        
            if (!allowedTypes.includes(image.type)) {
                imageError = i18next.t("Invalid image format! Only JPG, PNG allowed.");
                shouldScroll = true;
                break;
            }
        
            if (image.size > maxSize) {
                imageError = i18next.t("Image size should not exceed 5MB!");
                shouldScroll = true;
                break;
            }
        }
        
        if (imageError) {
            this.setState({ image_err: imageError, is_disabled: false }, () => {
                if (shouldScroll && this.task_name) {
                    setTimeout(() => {
                        this.task_name.scrollIntoView({ behavior: "smooth", block: "center" });
                    }, 100);
                }
            });
            err++;
        } else {
            this.setState({ image_err: "" });
        }



        const task_name = this.state.task_name !== undefined && this.state.task_name !== ''
        ? this.state.task_name
        : this.state.booking_details?.bookedName;
        const chosen_cat = this.state.chosen_cat || this.state.booking_details?.parent_category_id;
        const chosen_subcat = this.state.chosen_subcat || this.state.booking_details?.subcategory_id;
        // const date_of_service = this.state.date_of_service || this.state.booking_details?.formatted_date;
        // const sale_price = this.state.sale_price || this.state.booking_details?.price;
        const sale_price = this.state.sale_price !== undefined && this.state.sale_price !== ''
        ? this.state.sale_price
        : this.state.booking_details?.price;

        
        const description = this.state.description !== undefined && this.state.description !== ''
        ? this.state.description
        : this.state.booking_details?.bookedFor;

        const selectedCountry = this.state.selectedCountry || this.state.booking_details?.country;
        const selectedCity = this.state.selectedCity || this.state.booking_details?.city;
    
        const date_of_service = this.state.date_of_service || this.state.booking_details?.date;



        // Validation checks
        if (!this.state.task_name || this.state.task_name === '') {
            this.setState({ task_name_err: i18next.t("Title is required!"), is_disabled: false });
            this.task_name.scrollIntoView({ behavior: "smooth" });
            err++;
        } else {
            this.setState({ task_name_err: "" });
        }
    
        if (!chosen_cat || chosen_cat === '' || chosen_cat === 'Select Category') {
            this.setState({ cat_err: i18next.t("Category is required!"), is_disabled: false });
            // this.task_name.scrollIntoView({ behavior: "smooth" });
            err++;
        } else {
            this.setState({ cat_err: "" });
        }
    
        if (!this.state.booking_details?.subcategory_id) {
            this.setState({ sub_cat_err: i18next.t("Sub Category is required!"), is_disabled: false });
            // this.task_name.scrollIntoView({ behavior: "smooth" });
            err++;
        } else {
            this.setState({ sub_cat_err: "" });
        }
    
        var current_date = new Date();
        var chosen_date = new Date(date_of_service);
        chosen_date.setHours(0, 0, 0, 0);
        if (!date_of_service || chosen_date < current_date) {
            this.setState({ date_err: i18next.t('Choose Future Date!'), is_disabled: false });
            this.task_name.scrollIntoView({ behavior: "smooth" });
            err++;
        } else {
            this.setState({ date_err: '' });
        }
    
        if (!this.state.sale_price || this.state.sale_price === '') { 
            this.setState({ task_price_err: i18next.t("Price is required!"), is_disabled: false });
            err++;
        }else if(Number(this.state.sale_price) <= 0){
            this.setState({ task_price_err: i18next.t("Price should be more than 0"), is_disabled: false });
            this.task_name.scrollIntoView({ behavior: "smooth" });
            err++;
        } 
        else {
            this.setState({ task_price_err: "" });
        }
        
          if(!this.state.description ||  this.state.description === '') {
                    this.setState({ description_err : i18next.t('Description is required!'),is_disabled : false  });
                    err++;
                }
                else {
                    this.setState({ description_err : ''  });
                }
    
        if (err === 0) {
            const config = {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            };
    
            const params = new FormData();
    
    //         const selectedDate = date_of_service
    //             ? moment(date_of_service).locale('en').format('DD/MM/YYYY')
    //             : this.state.booking_details.formatted_date;
    // console.log('selectedDate',selectedDate);

    const selectedDate = date_of_service
    ? moment(date_of_service, moment.ISO_8601).locale('en').format('YYYY-MM-DD')
    : moment(this.state.booking_details?.date, moment.ISO_8601).locale('en').format('YYYY-MM-DD');

console.log('Final Date Sent:', selectedDate);

    
            params.append('date', selectedDate);
            params.append('parent_category_id', chosen_cat);
            // params.append('subcategory_id', chosen_subcat);
            params.append('subcategory_id', this.state.booking_details?.subcategory_id);
            params.append('user_id', user_info.user_id);
            params.append('sale_price', sale_price);
            params.append('name', task_name);
            params.append('country', selectedCountry);
            params.append('city', selectedCity);
            params.append('bookingId', booking_id);
            params.append('description', description);
    
            this.state.images.forEach((image) => {
                if (image.isExisting) {
                    params.append('existing_images', image.url);
                } else {
                    params.append('images', image.file);
                }
            });
            console.log('params',this.state.images);
            
    
            axios.post(`${process.env.REACT_APP_BASE_URL}/web/api/v1/user/updatelisting`, params, config)
                .then((res) => {
                    console.log('UPDATEResponse:', res);
                    if (res.status === 200) {
                        if (res.data.status_code === 200) {
                            Toast.fire({
                                icon: 'success',
                                title: i18next.t('Changes Saved Successfully!')
                            });
                            this.props.history.push('/user/my-listing');
                        } else if (res.data.status_code === 401) {
                            this.setState({ is_disabled: false });
                            // Handle session expiration or unauthorized access
                        } else {
                            this.setState({ is_disabled: false });
                            Toast.fire({
                                icon: 'warning',
                                title: "Something went wrong!"
                            });
                        }
                    }
                }).catch((err) => {
                    console.log('Error:', err);
                });
        }
    };

    date_of_service = (date, dateString) => {
        this.setState({
            date_of_service: date,
            booking_details: {
                ...this.state.booking_details,
                formatted_date: dateString, // Store the new date string
            }
        });
    };
    

    
    get_service = (value) => {
        this.setState({ chosen_service: value });
    }
    get_services = (value) => {
        this.setState((prevState) => ({
            booking_details: {
                ...prevState.booking_details,
                subcategory_name: value, // Update selected subcategory
                service_name: "", // Reset service selection
            },
            chosen_service: "Select Service",
            services: [],
        }));
    
        const config = {
            headers: {
                "Content-type": "application/x-www-form-urlencoded",
            },
        };
    
        const params = new URLSearchParams();
        params.append("parent_category_id", this.state.chosen_cat);
        params.append("subcategory_id", value);
    
        axios
            .post(`${process.env.REACT_APP_BASE_URL}/web/api/v1/services`, params, config)
            .then((res) => {
                if (res.data.status_code === 200) {
                    this.setState({
                        services: res.data.services,
                        chosen_subcat: value, // Store selected subcategory
                    });
                } else {
                    console.log(res.data.message);
                }
            })
            .catch((error) => {
                console.error("Error fetching services:", error);
            });
    };
    
    isNumber = (e) => {
        var rgx = /^[0-9]*\.?[0-9]*$/;
        var split_price = e.target.value.split('.');
        if (rgx.test(e.target.value)) {
            if ((split_price[0] && split_price[0].length !== undefined && split_price[0].length <= 6)) {
                if (!split_price[1]) {
                    this.setState({ need_price: e.target.value })
                }
                else {
                    if ((split_price[1] && split_price[1].length !== undefined && split_price[1].length <= 2)) {
                        this.setState({ need_price: e.target.value })
                    }
                }

            }
        }
        if (e.target.value.length === 0) {
            this.setState({ need_price: e.target.value })
        }
    }
    disabledDate = (current) => {
        return moment() >= current || moment().add(1, 'month') <= current;
    }
    trigger_location_autocomplete = () => {
        // alert('autohi');
        this.autocomplete(document.getElementById("manual_location"), this.state.general_info.cities);
        var el = document.getElementById('manual_location');
        el.dispatchEvent(new Event('input'));
    }
    autocomplete(inp, arr) {
        var currentFocus;
        var rm = this;
        /*execute a function when someone writes in the text field:*/
        inp.addEventListener("input", function (e) {
            var a, b, i, val = this.value;
            /*close any already open lists of autocompleted values*/
            closeAllLists();
            // if (!val) { return false;}
            currentFocus = -1;
            /*create a DIV element that will contain the items (values):*/
            a = document.createElement("DIV");
            a.setAttribute("id", this.id + "autocomplete-list");
            a.setAttribute("class", "autocomplete-items");
            /*append the DIV element as a child of the autocomplete container:*/
            this.parentNode.appendChild(a);
            /*for each item in the array...*/
            for (i = 0; i < arr.length; i++) {
                /*check if the item starts with the same letters as the text field value:*/
                if (arr[i].substr(0, val.length).toUpperCase() === val.toUpperCase()) {
                    /*create a DIV element for each matching element:*/
                    b = document.createElement("DIV");
                    /*make the matching letters bold:*/
                    b.innerHTML = "<strong>" + arr[i].substr(0, val.length) + "</strong>";
                    b.innerHTML += arr[i].substr(val.length);
                    /*insert a input field that will hold the current array item's value:*/
                    b.innerHTML += "<input type='hidden' value='" + arr[i] + "'>";
                    /*execute a function when someone clicks on the item value (DIV element):*/
                    b.addEventListener("click", function (e) {
                        /*insert the value for the autocomplete text field:*/
                        inp.value = this.getElementsByTagName("input")[0].value;
                        rm.setState({ manual_location: inp.value });
                        /*close the list of autocompleted values,
                        (or any other open lists of autocompleted values:*/
                        closeAllLists();
                    });
                    a.appendChild(b);
                }
            }
        });
        /*execute a function presses a key on the keyboard:*/
        inp.addEventListener("keydown", function (e) {
            var x = document.getElementById(this.id + "autocomplete-list");
            if (x) x = x.getElementsByTagName("div");
            if (e.keyCode === 40) {
                /*If the arrow DOWN key is pressed,
                increase the currentFocus variable:*/
                currentFocus++;
                /*and and make the current item more visible:*/
                addActive(x);
            } else if (e.keyCode === 38) { //up
                /*If the arrow UP key is pressed,
                decrease the currentFocus variable:*/
                currentFocus--;
                /*and and make the current item more visible:*/
                addActive(x);
            } else if (e.keyCode === 13) {
                /*If the ENTER key is pressed, prevent the form from being submitted,*/
                e.preventDefault();
                if (currentFocus > -1) {
                    /*and simulate a click on the "active" item:*/
                    if (x) x[currentFocus].click();
                }
            }
        });
        function addActive(x) {
            /*a function to classify an item as "active":*/
            if (!x) return false;
            /*start by removing the "active" class on all items:*/
            removeActive(x);
            if (currentFocus >= x.length) currentFocus = 0;
            if (currentFocus < 0) currentFocus = (x.length - 1);
            /*add class "autocomplete-active":*/
            x[currentFocus].classList.add("autocomplete-active");
        }
        function removeActive(x) {
            /*a function to remove the "active" class from all autocomplete items:*/
            for (var i = 0; i < x.length; i++) {
                x[i].classList.remove("autocomplete-active");
            }
        }
        function closeAllLists(elmnt) {
            /*close all autocomplete lists in the document,
            except the one passed as an argument:*/
            var x = document.getElementsByClassName("autocomplete-items");
            for (var i = 0; i < x.length; i++) {
                if (elmnt !== x[i] && elmnt !== inp) {
                    x[i].parentNode.removeChild(x[i]);
                }
            }
        }
        /*execute a function when someone clicks in the document:*/
        document.addEventListener("click", function (e) {
            closeAllLists(e.target);
        });
    }
    get_to_back = () => {
        this.props.history.goBack();
    }
    handleClick = (index) => {
        this.setState({ activeIndex: index });
    };
    render() {
        var settings = {
            dots: false,
            infinite: false,
            speed: 300,
            slidesToShow: 9.5,
            slidesToScroll: 1,
            swipeToSlide: true,
            focusOnSelect: true,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 8,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 6,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1
                    }
                }
            ]
        };
        return (
          
            <React.Fragment>
    <div className="container">
        <div className="pt-5">
            <div className="d-flex justify-content-between align-items-center">
                <h4 className="fM" ref={(el) => { this.task_name = el; }}>{i18next.t('Edit Your Business Listing')}</h4>
                <div className="d-flex p-3 align-items-center hover-cont" onClick={this.get_to_back}>
                    <ArrowLeftOutlined />
                    &nbsp;
                    <span>{i18next.t("Back")}</span>
                </div>
            </div>

            <div>
                {/* Image Preview Section */}
                <div 
                    onDragOver={this.handleDragOver}
                    onDrop={this.handleImageUpload}
                    className="upload_input"
                    style={{
                        border: "2px dashed #aaa",
                        padding: "40px",
                        textAlign: "center",
                        cursor: "pointer",
                        backgroundColor: "#f9f9f9"
                    }}
                >
                    <p>Upload Upto 15 Images</p>
                    <p style={{ fontSize: "14px", color: "#666" }}>Drag and drop images here or click to upload</p>
                    <input
                        type="file"
                        accept="image/*"
                        multiple
                        onChange={this.handleImageUpload}
                        // style={{ display: "none" }}
                        id="fileInput"
                    />
                                                <p className="text-danger">{this.state.image_err}</p>
                    {/* <label htmlFor="fileInput" style={{ cursor: "pointer", color: "#007bff", textDecoration: "underline" }}>
                        Browse Files
                    </label> */}
                </div>
                <Slider {...settings} className='sliderupload_div'>
                                {this.state.images && this.state.images.map((image, index) => (
                                    <div key={index} className={`sliderupload_card ${this.state.activeIndex === index ? "active" : ""}`}
                                        onClick={() => this.handleClick(index)}>
                                        <div className='slideruploadimg_div'>
                                            <img
                                                // src={image.isExisting ? `https://services.hitasoft.in/juan/public/img/bookings/${image.url}` : image.url}
                                                src={image.isExisting ? `https://emprende.net/public/img/bookings/${image.url}` : image.url}

                                                alt="Preview"
                                                width="100"
                                                height="100"
                                                style={{ borderRadius: "5px" }}
                                            />
                                        </div>
                                        <button onClick={() => this.removeImage(index)}>
                                            <img src={Trash} />
                                        </button>
                                    </div>
                                ))}
                            </Slider>
                {/* <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", marginBottom: "10px", marginTop: "15px" }}>
                    {this.state.images && this.state.images.map((image, index) => (

                        <div key={index} style={{ position: "relative", width: "100px", height: "100px" }}>
                              <img
                src={image.isExisting ? `http://services.hitasoft.in/juan/public/img/bookings/${image.url}` : image.url}
                alt="Preview"
                width="100"
                height="100"
                style={{ borderRadius: "5px" }}
            />
                            <button
                                onClick={() => this.removeImage(index)}
                                style={{
                                    position: "absolute",
                                    top: "77%",
                                    right: "31%",
                                    transform: "translate(-50%, -50%)",  // Centers the icon
                                    background: "#b3b3b3", // Semi-transparent back
                                    color: "#ff4800",
                                    border: "none",
                                    cursor: "pointer",
                                    borderRadius: "50%",
                                    width: "20px",
                                    height: "20px",
                                    fontSize: "14px",
                                    fontWeight: "bold",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    padding: "2px"
                                }}
                            >
                                <Trash2 size={16} />
                            </button>
                        </div>
                    ))}
                </div> */}

                <div className="col-12 col-sm-12 col-md-10 col-lg-8 col-xl-6 px-0">
                    <div>
                        {/* Title */}
                        <p className="mb-2">{i18next.t('Title')}</p>

                        
                        <div className="mb-3">
                            <Input
                                size="large"
                                maxLength="60"
                                placeholder={i18next.t("Enter business title")}
                                onChange={(e) => { this.setState({ task_name: e.target.value }) }}
                                value={this.state.task_name}
                            />
                            <p className="text-danger">{this.state.task_name_err}</p>
                        </div>


                        {/* Category Selection */}
                        <p className="mb-2">{i18next.t("Select Category")}</p>
                        <div className="mb-3">
                            {this.state.booking_details && <Select
                                className="w-100"
                                value={this.state.booking_details.parent_category_name}
                                onChange={this.get_subcategories}
                            >
                                {
                                    this.state.categories.length > 0 &&
                                    this.state.categories
                                    .filter(i => i.section && i.section === 'business_sale') // Only show business_sale categories
                                    .map((i, k) => (
                                        <Option key={k} value={i.parent_category_id}>{i.parent_category_name}</Option>
                                    ))
                                }
                            </Select>}
                            <p className="text-danger">{this.state.cat_err}</p>
                        </div>

                        {/* Sub Category */}
                        <p className="mb-2">{i18next.t("Select Sub Category")}</p>
                        <div className="mb-3">
                           {this.state.booking_details && <Select
                                className="w-100"
                                value={this.state.booking_details.subcategory_name}
                                onChange={this.get_services}
                            >
                                {
                                    this.state.sub_categories.length > 0 &&
                                    this.state.sub_categories.map((i, k) => (
                                        <Option key={k} value={i.subcategory_id}>{i.subcategory_name}</Option>
                                    ))
                                }
                            </Select>}

                            <p className="text-danger">{this.state.sub_cat_err}</p>
                        </div>

                        {/* Country */}
<p className="mb-2">{i18next.t("Select Country")}</p>
<div className="mb-3">
    <Select
        className="w-100"
        value={this.state.booking_details?.country || ""}
        onChange={this.handleCountryChange}
    >
        {/* <Option value="">{i18next.t("Select Country")}</Option> */}
        {this.state.countries.map((country, k) => (
            <Option key={k} value={country.name}>
                {country.name}
            </Option>
        ))}
    </Select>
    <p className="text-danger">{this.state.country_err}</p>
</div>

{/* City */}
<p className="mb-2">{i18next.t("Select City")}</p>
<div className="mb-3">
    <Select
        className="w-100"
        value={this.state.booking_details?.city || ""}
        onChange={this.handleCityChange}
        disabled={this.state.cities.length === 0 && !this.state.booking_details?.city} // Enable only when cities are available
    >
        {/* <Option value="">{i18next.t("Select City")}</Option> */}
        {this.state.cities.map((city, k) => (
            <Option key={k} value={city}>
                {city}
            </Option>
        ))}
    </Select>
    <p className="text-danger">{this.state.city_err}</p>
</div>
                        {/* Sale Price */}
                        <p className="mb-2">{i18next.t('Sale Price')}</p>
                        <div className="mb-3">
                            {/* <Input
                                size="large"
                                placeholder={i18next.t("Enter Sale Price")}
                                onChange={(e) => { this.setState({ sale_price: e.target.value }) }}
                                value={this.state.sale_price} // Use sale_price here
                            /> */}

<Input
    size="large"
    placeholder={i18next.t("Enter Sale Price")}
    onChange={(e) => { this.setState({ sale_price: e.target.value }) }}
    onKeyUp={(e) => {
        let value = e.target.value;
        if (!/^\d*\.?\d*$/.test(value)) {  
            value = value.replace(/[^0-9.]/g, ""); // Remove invalid characters
            this.setState({ sale_price: value });
        }
    }}
    value={this.state.sale_price} 
/>
                            <p className="text-danger">{this.state.task_price_err}</p>
                        </div>

                        {/* Start Date */}
                        <div className="mt-4">
                            <p className="mb-2">{i18next.t("Start Date")}</p>
                            <div className="mb-3">
                                <DatePicker
                                    inputReadOnly={true}
                                    disabledDate={this.disabledDate}
                                    onChange={this.date_of_service}
                                    format={this.state.date_format}
                                    size="large"
                                    placeholder={i18next.t("Choose your date")}
                                    // value={this.state.booking_details && this.state.booking_details.formatted_date}
                                    // value={this.state.booking_details && this.state.booking_details.formatted_date ? moment(this.state.booking_details.formatted_date, this.state.date_format, true) : null}

                                    value={
                                        this.state.booking_details && this.state.booking_details.formatted_date
                                            ? moment(this.state.booking_details.formatted_date, 'DD/MM/YYYY') // Change format to match the string format
                                            : null
                                    }
                                />
                                <p className="text-danger">{this.state.date_err}</p>
                            </div>
                        </div>



                        {/* description */}

                        <p className="mb-2">{i18next.t('Description')}</p>
                        <div className="mb-3">
                                    <TextArea
                                                maxLength={300} 
                                                placeholder={ i18next.t("Enter your details of your task") }
                                                onChange={(e)=> { this.setState({ description : e.target.value }) }}
                                                value={ this.state.description }
                                            />
                            <p className="text-danger">{this.state.description_err}</p>
                        </div>




                        {/* Save and Delete Buttons */}
                        <div className="d-flex justify-content-between align-items-center mt-4">
    {/* Delete Button */}
    <Button
        onClick={this.deleteListing}
        size="large"
        className="Btns SecondaryBtn lg fM mb-2 mb-sm-0"
        style={{
            backgroundColor: '#333333', // Change background to black
            color: 'white', // Ensure text is white
            width: '49%' // Increase width (you can adjust as needed)
        }}
    >
        {i18next.t("Delete")}
    </Button>

    {/* Save Button */}
    <Button
        disabled={this.state.is_disabled}
        onClick={this.save_need}
        size="large"
        className="Btns PrimaryBtn lg fM mb-2 mb-sm-0"
        style={{
            width: '49%' // Increase width (you can adjust as needed)
        }}
    >
        {this.state.is_disabled === true ? <LoadingOutlined /> : i18next.t("Save")}
    </Button>
</div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</React.Fragment>


        );
    }
}
export default MyListingDetail;